module.exports = {
  webRoutes: [
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/MIndex'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/index/hotNews',
      name: 'indexHotNews',
      component: () => import('@/views/MIndex/pages/hotNews'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/index/detail',
      name: 'indexDetail',
      component: () => import('@/views/MIndex/pages/detail'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/index/activity',
      name: 'indexActivity',
      component: () => import('@/views/MIndex/pages/activity'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/index/service',
      name: 'indexService',
      component: () => import('@/views/MIndex/pages/service'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/index/carousel',
      name: 'indexCarousel',
      component: () => import('@/views/MIndex/pages/carousel'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/introductionCenter',
      name: 'introductionCenter',
      component: () => import('@/views/MIntroductionCenter'),
      meta: {
        title: '中心简介'
      }
    },
    {
      path: '/informationService',
      name: 'informationService',
      component: () => import('@/views/MInformationService'),
      meta: {
        title: '信息服务'
      }
    },
    {
      path: '/informationService/detail',
      name: 'informationServiceDetail',
      component: () => import('@/views/MInformationService/pages/detail'),
      meta: {
        title: '信息服务'
      }
    },
    {
      path: '/informationService/consult/detail',
      name: 'informationServiceConsultDetail',
      component: () => import('@/views/MInformationService/pages/detail'),
      meta: {
        title: '信息服务/相关咨询'
      }
    },
    {
      path: '/informationService/analysis/detail',
      name: 'informationServiceAnalysisDetail',
      component: () => import('@/views/MInformationService/pages/detail'),
      meta: {
        title: '信息服务/分析报告'
      }
    },
    {
      path: '/informationService/activity',
      name: 'informationServiceActivity',
      component: () => import('@/views/MInformationService/pages/activity'),
      meta: {
        title: '信息服务竞赛/培训详情页'
      }
    },
    {
      path: '/informationService/compete/activity',
      name: 'informationServiceCompeteActivity',
      component: () => import('@/views/MInformationService/pages/activity'),
      meta: {
        title: '信息服务/竞赛动态'
      }
    },
    {
      path: '/informationService/lecture/activity',
      name: 'informationServiceLectureActivity',
      component: () => import('@/views/MInformationService/pages/activity'),
      meta: {
        title: '信息服务/培训讲座'
      }
    },
    {
      path: '/resourceNavigation',
      name: 'resourceNavigation',
      component: () => import('@/views/MResourceNavigation'),
      meta: {
        title: '资源导航'
      }
    },
    {
      path: '/resourceNavigation/detail',
      name: 'resourceNavigationDetail',
      component: () => import('@/views/MResourceNavigation/pages/detail'),
      meta: {
        title: '资源导航详情页'
      }
    },
    // 资源导航详情页进入新闻速递详情页
    {
      path: '/resourceNavigation/news/detail',
      name: 'resourceNavigationNewsDetail',
      component: () => import('@/views/MResourceNavigation/pages/detail'),
      meta: {
        title: '资源导航详情页'
      }
    },
    // 资源导航详情页进入政策详情页
    {
      path: '/resourceNavigation/policy/detail',
      name: 'resourceNavigationPolicyDetail',
      component: () => import('@/views/MResourceNavigation/pages/detail'),
      meta: {
        title: '资源导航详情页'
      }
    },
    // 首页进入新闻速递详情页
    {
      path: '/index/news/detail',
      name: 'indexResourceNavigationNewsDetail',
      component: () => import('@/views/MResourceNavigation/pages/detail'),
      meta: {
        title: '资源导航详情页'
      }
    },
    // 首页进入政策详情页
    {
      path: '/index/policy/detail',
      name: 'indexResourceNavigationPolicyDetail',
      component: () => import('@/views/MResourceNavigation/pages/detail'),
      meta: {
        title: '资源导航详情页'
      }
    },
    {
      path: '/index/personal',
      name: 'personal',
      component: () => import('@/views/Personnal'),
      meta: {
        title: '个人中心'
      },
      redirect: '/index/personal/user',
      children: [
        {
          path: '/index/personal/user',
          name: 'user',
          component: () => import('@/views/Personnal/user/userInfo'),
          meta: {
            title: '用户信息'
          }
        },
      ]
    }
  ]
}
